import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import CommonModal from '../CommonModal/CommonModal';
import PriceBreakdownModalContent from './PriceBreakdownModalContent';
import TrimPanel from './TrimPanel';
import themeStyles from './PriceBreakdownModal.styles';
import usePriceBreakdownModal from '../PaymentCalculator/usePriceBreakdownModal';
import useScreenSize from '../../utils/hooks/useScreenSize';
import { Print, Screen } from '../../utils/components/ForPrint.styles';
import { PrintModalWorkaround } from '../CommonModal/CommonModal.styles';
const ContentWrapper = themeStyles.apply(Box, 'ContentWrapper');
const PriceBreakdownModal = () => {
    const { t } = useTranslation();
    const { isLarge, isExtraLarge } = useScreenSize();
    const { isModalOpen, closeModal } = usePriceBreakdownModal();
    const handleSubmitModalForm = () => {
        closeModal();
    };
    const modalWidth = (isExtraLarge && '1200px') || (isLarge && '854px') || '100vw';
    return (React.createElement(Box, { "data-testid": "cy-price-breakdown-modal", position: "relative" },
        React.createElement(PrintModalWorkaround, null),
        React.createElement(CommonModal, { handleCloseModal: handleSubmitModalForm, handleSubmit: handleSubmitModalForm, showModal: isModalOpen, title: t('Pages.Bap.priceBreakdownLabel'), width: modalWidth, styling: isLarge || isExtraLarge ? 'iframe' : 'fullOverlay' },
            React.createElement(ContentWrapper, { "data-body-scroll-lock-ignore": true, "data-testid": "cy-price-breakdown-wrapper" },
                React.createElement(Screen, null,
                    React.createElement(TrimPanel, null),
                    React.createElement(PriceBreakdownModalContent, null)),
                React.createElement(Print, null,
                    React.createElement(TrimPanel, null),
                    React.createElement(PriceBreakdownModalContent, { forPrint: true }))))));
};
export default PriceBreakdownModal;
